export enum ALERT_POSITION {
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
  TOP_CENTER = 'top-center',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
}

export enum ALERT_TYPE {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  CAUTION = 'caution',
  INFO = 'info',
  BASIC = 'basic',
}

export type IAlertOptions = {
  title?: string
  type?: ALERT_TYPE
  timeout?: number | 'none'
  actions?: {
    [label: string]: () => void
  }
}

export interface IAlert extends IAlertOptions {
  id: string
  title: string
  message: string
  type: ALERT_TYPE
}
